/* eslint-disable import/prefer-default-export */
/**
 * Term watchers helper functions
 * @module services/term/watchers-helpers
 */
import { EN } from 'services/languages/constants'
import { getTerms } from '.'
import { setMultipleTerms } from './actions'

/**
 * Get multiple terms and dispatch actions
 * @param {Object} options The options
 * @param {Number[]} options.termIds The term ids to load
 * @param {import('redux').Dispatch} options.dispatch A redux dispatch function
 * @param {String} options.language The requested language
 * @param {Map} options.auth The auth state
 */
export async function getMultipleTerms (options = {}) {
  const { termIds, language = EN, dispatch, auth } = options
  const data = await getTerms({
    ids: termIds,
    language,
    auth,
  })
  dispatch(setMultipleTerms(termIds, language, data))
}
